<div class="activity-drawer-shell cipx-form-container">
  <div class="activity-drawer-body cipx-scrollable-content">
    @if (accountOverviewLink) {
      <a class="activity-drawer-account-link" [routerLink]="accountOverviewLink">
        {{ accountLabel }}
      </a>
    }

    <sbd-doug-frontend-task-viewer-content-right-content-stage-column-task-create-form
      class="activity-follow-up-task-form"
      [_taskSetService]="_taskSetService"
      [selectedAccount]="selectedAccount"
      [taskTypeCode]="'generic-task'"
      [initialTaskDraft]="initialTaskDraft"
      [showFooter]="false"
      (draftChange)="onTaskDraftChanged($event)"
      (close)="
        onTaskCreateFormClose()
      "></sbd-doug-frontend-task-viewer-content-right-content-stage-column-task-create-form>
  </div>

  <sbd-doug-frontend-common-drawer-footer
    [buttons]="drawerFooterButtons"
    [buttonPosition]="'start'"
    [componentRef]="componentSelf"></sbd-doug-frontend-common-drawer-footer>
</div>
